import Util from '@/helper/Utility.js';

export function AddCartModel() {
    this.list = [];
    this.mode = 'add';

    /**
     * Add item to cart.
     * @param {string|number} campaignId
     * @param {number} qty
     */
    this.addItem = (campaignId, qty) => {
        this.list.push({
            id: campaignId,
            qty: qty
        });
        return this;
    };
    /**
     * Set cart mode.
     * @param {String} mode
     */
    this.setMode = mode => {
        this.mode = mode;
    };
    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var params = {
            json: JSON.stringify(this.list),
            mode: this.mode
        }

        return Util.cleanObjectEmptyStr(params);
    };
}
